var version = "9.14.4";

export { version as v };
//# sourceMappingURL=package-c1acb40c.js.map
